import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BooksPage = lazy(() => import('../pages/books/page'));
const AudiobooksPage = lazy(() => import('../pages/audiobooks/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FeedbackPage = lazy(() => import('../pages/feedback/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/books',
    element: <BooksPage />,
  },
  {
    path: '/audiobooks',
    element: <AudiobooksPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/feedback',
    element: <FeedbackPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
